import MinLengthValidationRule from './MinLengthValidationRule';

class PasswordValidationRule extends MinLengthValidationRule {
  validate(val) {
    // Password requirements: at least 8 characters, a lowercase letter, an uppercase letter, a number, no parts of your username.

    val = val || '';
    return super.validate(val) && val.toLowerCase() !== val && val.toUpperCase() !== val && /(\d)+/.test(val);
  }
}

export default PasswordValidationRule;



// WEBPACK FOOTER //
// ./src/common/core/validation/validationRules/PasswordValidationRule.js